"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
var ClientInfo = /** @class */ (function () {
    function ClientInfo() {
        this.aulaUID = js_cookie_1.default.get('aulaUID');
        this.client = (0, ua_parser_js_1.default)();
    }
    ClientInfo.prototype.getUniqueDeviceId = function () {
        if (!this.aulaUID) {
            this.aulaUID = uuidv4();
            js_cookie_1.default.set('aulaUID', this.aulaUID, {
                expires: 730,
                domain: process.env.LOCAL ? 'localhost' : '.aula.education',
            });
        }
        return Promise.resolve(this.aulaUID);
    };
    ClientInfo.prototype.getInfo = function () {
        return this.client;
    };
    return ClientInfo;
}());
exports.default = ClientInfo;
